import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { Title } from '../styled';
import { InvestementContainer, InvestStep } from './styled';

const { Text } = Common;

const MulaiInvestasiSteps = () => (
  <>
    <Title>3 Langkah Mudah Investasi Saham di Stockbit</Title>
    <InvestementContainer>
      <InvestStep>
        <Image src="/images/mulai-investasi/step1.svg" />
        <Text size="17px" align="center">
          Pastikan Anda
          <br /> memiliki akun Stockbit
        </Text>
      </InvestStep>
      <InvestStep>
        <Image src="/images/mulai-investasi/step2.svg" />
        <Text size="17px" align="center">
          Lakukan pengisian <br /> formulir pembukaan rekening <br />
          secara online
        </Text>
      </InvestStep>
      <InvestStep>
        <Image src="/images/mulai-investasi/step3.svg" />
        <Text size="17px" align="center">
          Deposit <br /> dan Beli saham
        </Text>
      </InvestStep>
    </InvestementContainer>
  </>
);

export default MulaiInvestasiSteps;
